/* @flow */

import * as React from 'react';

const TradingAccountRegion: React.StatelessFunctionalComponent<*> = (props: Object) => {
  // eslint-disable-next-line
  const tradingAccountRegion: any = [
    {
      id: 1,
      label: 'general:trading_accounts.labels.region',
      value: props.details.details.region.name,
    },
  ];

  const t: Function = props.t;
  return (
    <React.Fragment>
      <h3>{t('general:trading_accounts.labels.region')}</h3>
      <table>
        <tbody>
          {tradingAccountRegion.map((item: any, key: number) => (
            <tr key={item.id}>
              <td>
                <b>{t(item.label)}:</b>
              </td>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default TradingAccountRegion;
